var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#46AFEB","min-height":"100vh","padding-top":"2em"}},[_c('v-container',{staticStyle:{"background-color":"#FFF"}},[_c('h1',[_vm._v("404 Страница не найдена")]),_c('p',[_vm._v("Извините, страницы для \""+_vm._s(_vm.notFoundPath)+"\" не существует.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }